import Hero from "../components/Hero";
import EditorialMarquee from "../components/EditorialMarquee";
import Services from "../components/Services";
import Method from "../components/Method";
import Guarantees from "../components/Guarantees";
import Stats from "../components/Stats";
import About from "../components/About";
import GoogleReviews from "../components/GoogleReviews";
import Gallery from "../components/Gallery";
import Faq from "../components/Faq";
import Contact from "../components/Contact";
import DepartmentLinks from "../components/DepartmentLinks";
import Seo from "../components/Seo";

export default function Home() {
  return (
    <main data-testid="home-page">
      <Seo
        path="/"
        description="Le Bon Dépanneur : dépannage d'urgence 24/7 en plomberie, serrurerie et électricité à Paris et en Île-de-France. Un artisan certifié chez vous en 30 minutes, devis clair et sans surprise."
      />
      <Hero />
      <EditorialMarquee />
      <Services />
      <Method />
      <Guarantees />
      <Stats />
      <About />
      <GoogleReviews title="Ce que disent nos clients" subtitle="Plus de 1 200 avis Google sur nos interventions en plomberie, serrurerie et électricité." />
      <Gallery />
      <DepartmentLinks />
      <Faq />
      <Contact />
    </main>
  );
}
